import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=e74b33b4&scoped=true"
import script from "./add-form.vue?vue&type=script&lang=js"
export * from "./add-form.vue?vue&type=script&lang=js"
import style0 from "./add-form.vue?vue&type=style&index=0&id=e74b33b4&prod&lang=scss&scoped=true"
import style1 from "./add-form.vue?vue&type=style&index=1&id=e74b33b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74b33b4",
  null
  
)

export default component.exports